import { Link } from 'react-router-dom';
import PageBasicTemplate from '../components/PageBasicTemplate';
import CompanyValues from '../components/redesign/CompanyValues';
import Arrow from '../components/redesign/Arrow';
import CompanyInfoSection from '../components/CompanyInfoSection';
import GreetingSection from '../components/redesign/GreetingSection';
export default function CompanyOverview() {
  return <PageBasicTemplate title="会社情報" sub_title="最先端のIT技術でビジネスに革新を。技術をつなぎ、新しい価値をともにつくります。">
    <div className="intro-layout"><h2 className="content-heading">技術に、意志を。<br />未来に、実装を。</h2><p>FRiCTONは、AIとソフトウェア、インフラの技術を活用し、お客様の事業を前へ進める会社です。ビジネスのユースケースを深く理解し、構想段階から開発・運用まで一貫して支援します。<br /><br />私たちが大切にするのは、革新・自動化・安定性。新しい価値をつくることと、その価値を届け続けることを、一つの仕事として考えています。</p></div>
    <CompanyValues />
    <GreetingSection />
    <div className="company-table"><CompanyInfoSection /><Link to="/contact" className="text-link" style={{ marginTop: 30 }}>お問い合わせ <Arrow /></Link></div>
  </PageBasicTemplate>;
}
